import React from "react";

const LandingShowMore = ({ hasMore, canShowLess, onMore, onLess }) => {
  if (!hasMore && !canShowLess) return null;

  return (
    <div className="landing-show-more-wrap">
      {hasMore ? (
        <button type="button" className="landing-show-more-btn" onClick={onMore}>
          more
        </button>
      ) : null}
      {canShowLess ? (
        <button type="button" className="landing-show-more-btn" onClick={onLess}>
          less
        </button>
      ) : null}
    </div>
  );
};

export default LandingShowMore;
